import {
  changeLinearFinalizaVenda,
  loadingWithOpt,
  Tipo,
} from "redux/features/blockuiSlice";
import { useAppDispatch } from "redux/hooks";

const useShowProgress = () => {
  const dispatch = useAppDispatch();
  return {
    showProgress: (params: {
      mensagens: Record<number, string>;
      porcentagemMaxima?: number;
    }) => {
      const { mensagens } = params;
      const porcentagemMaxima = params.porcentagemMaxima ?? 89;
      let msgAtual = mensagens[0] ?? "Registrando pedido";

      dispatch(
        loadingWithOpt({
          loading: true,
          tipo: Tipo.LINEAR,
          message: msgAtual,
          progress: 0,
        })
      );

      const sortedKeys = Object.keys(mensagens)
        .map(Number)
        .sort((a, b) => b - a);

      // Função para pegar o valor associado ao número mais próximo ou ao segundo maior
      const getMensagem = (num: number): string => {
        if (mensagens[num]) {
          msgAtual = mensagens[num];
          return msgAtual;
        }

        // Se não existe, retorna o segundo maior número menor que o número fornecido
        for (let i = 0; i < sortedKeys.length; i++) {
          if (sortedKeys[i] < num) {
            msgAtual = mensagens[sortedKeys[i]];
            return msgAtual;
          }
        }

        return msgAtual; // Retorna o valor padrão se não houver valor menor
      };

      for (let i = 0; i < porcentagemMaxima; i++) {
        if (i % 9 === Math.floor(Math.random() * 2)) {
          // eslint-disable-next-line
          setTimeout(() => {
            msgAtual = getMensagem(i);
            dispatch(
              changeLinearFinalizaVenda({ progress: i, message: msgAtual })
            );
          }, 55 * i);
        }
      }

      setTimeout(() => {
        dispatch(
          changeLinearFinalizaVenda({
            message: getMensagem(100),
            progress: porcentagemMaxima,
          })
        );
      }, 55 * (porcentagemMaxima + 1));
    },
    hideProgress: () => {
      dispatch(
        loadingWithOpt({
          loading: false,
          tipo: Tipo.CIRCULAR,
          message: "Salvando pedido",
          progress: 0,
        })
      );
    },
  };
};

export default useShowProgress;
